import { render } from "./FlowComponent.vue?vue&type=template&id=696dc59a"
import script from "./FlowComponent.vue?vue&type=script&lang=js"
export * from "./FlowComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__